const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWinLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.41 73.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M39.35,73.11h-5.42l-3.28-.45C15.25,70.12,3.01,57.93.48,42.54l-.45-3.28c.08-1.78-.11-3.65,0-5.42C2.03,2.72,41.06-11.52,62.93,11.02c21.55,22.2,7.1,60.13-23.59,62.09ZM35.12.57C6.59,1.84-9.35,34.24,7.38,57.58c16.15,22.54,50.9,18.87,62.17-6.36C80.45,26.85,61.7-.61,35.12.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M99.92,46.45l.83,3.37c.25-.04.23-.28.29-.46.18-.54.5-2.52.73-2.8.21-.26,1.05-.11,1.41-.12l.9,3.5.95-3.39,1.56-.13-1.64,5.4-1.55-.12-.95-3.25-.9,3.37-1.48-.04c-.22-.15-1.6-4.71-1.62-5.15-.01-.28,0-.17.2-.2.18-.03,1.23-.03,1.28.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M85.3,26.53l.97-3.37h1.46s.89,3.37.89,3.37l.89-3.38h1.62s-1.69,5.28-1.69,5.28l-1.48.14-.9-3.39c-.25.04-.23.28-.29.46-.18.54-.5,2.52-.73,2.8-.19.23-1.3.21-1.5,0l-1.69-5.28,1.56.13.88,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M111.3,23.16l1.04,3.37.81-3.25,1.43-.07.81,3.33c.21-.02.2-.21.26-.35.17-.43.71-2.94.84-3.02l1.47-.02-1.65,5.4c-.36,0-1.35.15-1.54-.11-.21-.29-.54-2.36-.75-2.91-.05-.14-.06-.33-.26-.35l-.83,3.37h-1.45s-1.65-5.2-1.65-5.2c-.01-.28,0-.18.2-.2.18-.03,1.2-.03,1.27.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M96.95,40c-.11.35-1.16.16-1.49.2-.08-.08.16-.71-.13-.68-.69,1.22-2.53.94-3.31-.15-1.72-2.39.54-6.3,3.31-4.05v-2.37l.22-.18c.12-.04.25-.02.38-.03.34-.03.81-.07,1.02.21v7.04ZM93.8,35.9c-1.15.27-1.02,2.76-.09,3.15,2.12.9,2.51-3.71.09-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M126.1,21.11v7.24c-.45.35-1.5.42-1.56-.34-1.22,1.15-3.15.67-3.69-.92-.9-2.65,1.21-5.42,3.76-3.42v-2.57h1.49ZM122.94,24.26c-1.23.28-1.12,3.6.75,3.19,1.28-.28,1.49-3.71-.75-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M126.1,32.76v7.45l-1.27-.02-.22-.53c-2.52,1.87-4.53-.64-3.79-3.31.48-1.7,2.52-2.27,3.79-1.02v-2.57h1.49ZM122.94,35.9c-1.17.35-1.17,3.66.89,3.19,1.19-.27,1.25-3.83-.89-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M109.29,21.11v7.45l-1.27-.02-.22-.53c-1.46,1.37-3.52.38-3.87-1.48-.47-2.55,1.6-4.69,3.87-2.85v-2.57h1.49ZM106.13,24.26c-1.11.33-1.18,3.66.89,3.19,1.14-.26,1.36-3.86-.89-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M104.82,39.67v2.3h-1.49v-7.18h1.36s.07.54.07.54c1.33-1.28,3.3-.68,3.83,1.05.79,2.62-1.25,5.14-3.76,3.28ZM105.59,35.9c-1.18.26-1.08,3.04.12,3.22,2.15.31,2.06-3.7-.12-3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M118.37,44.4v3.93c.59-.28,1.41-1.61,1.9-1.83.43-.19,1.15,0,1.62-.07.31.27-1.95,1.66-1.88,2.07l2.15,3.34-1.76-.07-1.43-2.23c-.98.32-.5,1.52-.61,2.3h-1.49v-7.25c.36-.39,1.01-.14,1.49-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M110.64,37.9c.22,1.01.73,1.43,1.8,1.18.44-.1.54-.59.84-.64s.84-.02,1.15.07c-.73,2.38-4.27,2.45-5.08.07-1.29-3.8,3.97-5.51,5.01-2.03.07.23.36,1.36,0,1.36h-3.73ZM110.64,36.82h2.3c-.07-1.38-2.03-1.28-2.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M102.78,37.9h-3.8c-.08,1.04.86,1.45,1.77,1.16.41-.13.5-.59.63-.62.16-.04,1.35-.12,1.26.2-.57,1.98-3.76,2.26-4.8.47-1.44-2.48.85-5.4,3.5-4.17,1.09.51,1.45,1.85,1.44,2.96ZM101.16,36.82c.06-1.32-2.23-1.32-2.17,0h2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M131.93,37.9h-3.8c.01.48.28,1.08.77,1.19,1.35.31,1.52-1,2.89-.65-.53,2.8-4.86,2.34-5.15-.47-.44-4.37,5.72-4.41,5.29-.07ZM130.43,36.82c-.18-1.34-2.1-1.29-2.3,0h2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M131.93,26.26h-3.8c-.08,1.04.86,1.45,1.77,1.16.41-.13.5-.59.63-.62.16-.04,1.35-.12,1.26.2-.7,2.42-4.92,2.22-5.15-.8-.33-4.3,5.7-4.22,5.29.06ZM130.43,25.18c-.24-1.34-2.09-1.34-2.3,0h2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M83.26,46.64c.11-.35,1.16-.16,1.49-.2l.07.68c.66-.83,1.75-1.07,2.69-.52,1.32.77.81,3.71.88,5.04l-.11.16c-.19.13-1.32.15-1.5-.14v-3.52c0-.91-1.9-.58-1.9,0v3.52l-.22.18c-.12.04-.25.02-.38.03-.34.03-.81.07-1.02-.21v-5.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M94.24,49.55h-3.8c-.04,1.08.8,1.46,1.77,1.16.41-.13.5-.59.63-.62.16-.04,1.35-.12,1.26.2-.6,2.08-3.9,2.27-4.85.39-2.26-4.46,5.19-6.48,4.99-1.13ZM92.62,48.6c.14-1.53-2.24-1.46-2.17,0h2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M115.12,40.21v-5.42h1.36s0,.68,0,.68c.71-.9,2.51-1.16,3.23-.18.13.17.43,1.03.43,1.2v3.52l-.22.18c-.12.04-.25.02-.38.03-.34.03-.81.07-1.02-.21v-3.66c0-.09-.44-.44-.61-.47-2.02-.39-1.02,3.12-1.34,4.2l-1.43.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M109.12,46.33c1.57-.19,2.96.73,3.13,2.35.46,4.15-5.22,4.36-5.53.78-.14-1.59.78-2.94,2.4-3.13ZM109.12,47.55c-1.32.3-1.26,3.83.89,3.19,1.08-.32,1.23-3.67-.89-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M93.53,23.04c4.24-.72,4.52,5.45.76,5.65-3.61.18-3.87-5.12-.76-5.65ZM93.33,24.4c-.69.57-.64,2.7.36,3.01,2.14.68,2.11-2.95.89-3.19-.31-.06-1-.03-1.25.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M90.85,40.21h-1.49v-3.59c0-.73-1.21-1.02-1.69-.47-.06.07-.34.7-.34.74v3.32c-.48-.06-1.13.18-1.49-.2v-5.21l1.27.02.29.52c.71-.78,2.13-.95,2.92-.21.16.15.54.8.54.95v4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M137.48,40.21l-1.43-.13c-.27-.84.27-3.48-.33-4-.74-.63-1.76.07-1.76.94v3.18c-.48-.06-1.13.18-1.49-.2v-5.21h1.49s.07.68.07.68c.54-1.31,3.46-.84,3.46.47v4.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M138.84,35.87h-.81s0-1.08,0-1.08h.81s.13-1.57.13-1.57l1.36-.06v1.63s1.08,0,1.08,0v1.08s-1.09,0-1.09,0v2.78s.14.32.23.34h.86s0,1.21,0,1.21c-.61.12-2.58-.02-2.58-.88v-3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M95.33,47.52h-.95s.06-.96.06-.96l.89-.13v-1.49s1.41,0,1.41,0l.08,1.49.96.06.13,1.02h-1.08s0,2.91,0,2.91c.26.33.71.18,1.09.2v1.22c-.55.08-2.58.05-2.58-.75v-3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M101.7,21.32l.22-.18c.12-.04.25-.02.38-.03.34-.03.81-.07,1.02.21v7.04l-.22.18c-.12.04-.25.02-.38.03-.34.03-.81.07-1.02-.21v-7.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M97.5,23.35c.11-.35,1.16-.16,1.49-.2l.13.81c.21-.73,1.19-1.01,1.9-.95v1.49c-.5-.31-1.9.18-1.9.75v3.11l-.22.18c-.12.04-.25.02-.38.03-.34.03-.81.07-1.02-.21v-5.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M112.95,46.44h1.36s.07.81.07.81c.51-.61,1.13-1.01,1.97-.95v1.49c-.66-.2-1.9.25-1.9,1.01v3.05h-1.49v-5.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    x: 118.51,
    y: 23.14,
    width: 1.49,
    height: 5.42
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M84.89,34.79v5.21c-.36.39-1.01.14-1.49.2v-5.42h1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M83.4,34.11v-1.36c1.19-.08,1.87-.11,1.36,1.3l-1.36.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    x: 118.51,
    y: 21.11,
    width: 1.49,
    height: 1.22
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "14 28.56 16.64 39.53 19.01 28.62 25.32 28.69 27.82 39.53 30.33 28.56 37.31 28.56 31.62 46.37 24.7 46.38 22.06 35.6 19.49 46.31 12.45 46.44 6.95 28.56 14 28.56"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M66.32,46.44h-6.78v-10.63c0-.13-.29-1.08-.38-1.25-.61-1.21-2.75-1.1-3.64-.26-.35.33-.86,1.46-.86,1.92v10.22h-6.78v-17.87h6.51v2.3c2.06-2.78,6.34-3.53,9.31-1.78,1.13.66,2.62,2.55,2.62,3.88v13.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    x: 38.8,
    y: 28.56,
    width: 6.78,
    height: 17.87
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    x: 38.8,
    y: 21.93,
    width: 6.78,
    height: 4.87
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinLight);
export default __webpack_public_path__ + "static/media/Win-light.99079cb04834cc6347ebd9352dc6a4ea.svg";
export { ForwardRef as ReactComponent };